import { render, staticRenderFns } from "./CompaniesNav.vue?vue&type=template&id=fda6d7fa"
import script from "./CompaniesNav.vue?vue&type=script&lang=js"
export * from "./CompaniesNav.vue?vue&type=script&lang=js"
import style0 from "./CompaniesNav.vue?vue&type=style&index=0&id=fda6d7fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports